module.exports = __webpack_public_path__ + "static/img/huishou.d1a15d8e.png";